<template>
  <div class="music-tree">
    Tree
  </div>
</template>

<script lang="ts">
export default {
  setup() {
    return {};
  }
};
</script>
